/**
 * Returns a plural suffix ('s' by default) if the count is not 1.
 *
 * @param count - The number of items
 * @param suffix - The plural suffix to append (default: 's')
 * @returns The suffix or an empty string
 */
export const pluralize = (count: number, suffix: string = 's'): string => {
  return count === 1 ? '' : suffix;
};
